import _startCase from 'lodash/startCase';
import * as R from 'ramda';
import { renameKeys } from './renameKeys';
export const makeOptionFromString = R.converge(R.mergeRight, [R.assoc('value', R.__, {}), R.assoc('label', R.__, {})]);
export const makeOptionsFromString = R.map(makeOptionFromString);
const valueEqualsLabel = R.converge(R.equals, [
    R.prop('value'),
    R.prop('label'),
]);
const makeOptionFromObject = ({ value, label }) => R.pipe(renameKeys({ [value]: 'value', [label]: 'label' }), R.pick(['value', 'label']));
const makeOptionsFromObject = (optionMap) => R.map(makeOptionFromObject(optionMap));
export const makeOptions = R.curry((optionMap, arr) => R.ifElse(R.always(valueEqualsLabel(optionMap)), R.pipe(R.pluck(optionMap.value), makeOptionsFromString), makeOptionsFromObject(optionMap))(arr));
export const makeOptionsFromArray = (arr) => arr.map((value) => ({
    label: _startCase(value),
    value,
}));
